/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import axios from "axios";
import { APIGateways } from "../../../utility/APIGateways";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";
import { redactPII } from "../../../utility/helpers";
import { PII_FIELDS } from "../../../utility/constants";

const COMPONENT_NAME = "Admin settingsManager/services/ExternalContactsService";

/**
 * Gets all external contacts
 */
export const getAgents = async () => {
	try {
		let response = await axios.get(`${APIGateways.voicemailEndpoint}/agents`, {
			headers: await getAuthHeader(),
		});

		return response.data.data;
	} catch (error) {
		v2.error(`Error getting all agents`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_AGENTS_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};

export const updateAgents = async (agentId, agent) => {
	try {
		let response = await axios.post(`${APIGateways.voicemailEndpoint}/agents/${agentId}`, agent, {
			headers: await getAuthHeader(),
		});
		return response;
	} catch (error) {
		v2.error(`Error updating agent`, {
			additionalData: {
				error: errorToObject(error),
				agentId,
				agent: redactPII(agent, PII_FIELDS.agent),
			},
			logCode: errorCodes.UPDATE_AGENTS_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};

export const getGlobalSettings = async () => {
	try {
		let response = await axios.get(`${APIGateways.voicemailEndpoint}/global/settings`, {
			headers: await getAuthHeader(),
		});
		return response.data;
	} catch (error) {
		v2.error(`Error getting the global settings.`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_GLOBAL_SETTINGS_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};
export const saveGlobalSettings = async (setting) => {
	try {
		let response = await axios.post(`${APIGateways.voicemailEndpoint}/global/settings`, setting, {
			headers: await getAuthHeader(),
		});
		return response;
	} catch (error) {
		v2.error(`Error updating global settings.`, {
			additionalData: {
				error: errorToObject(error),
				setting,
			},
			logCode: errorCodes.UPDATE_GLOBAL_SETTINGS_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};
export const getAgentById = async (agentId) => {
	try {
		let response = await axios.get(`${APIGateways.voicemailEndpoint}/agents/${agentId}`, {
			headers: await getAuthHeader(),
		});
		return response.data.connectUser || {};
	} catch (error) {
		v2.error(`Error getting agent by agentId `, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_AGENT_BY_ID_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};

export const syncAgents = async () => {
	try {
		let response = await axios.post(`${APIGateways.voicemailEndpoint}/agents/sync`, null, {
			headers: await getAuthHeader(),
		});
		return response;
	} catch (error) {
		v2.error(`Error sync the agents from amazon connect.`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.SYNC_AGENTS_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};
